__turbopack_context__.v({
  "card": "kw-YMG_card",
  "description": "kw-YMG_description",
  "list": "kw-YMG_list",
});
